export const MODE = {
  ANNUALLY: 1,
  QUARTERLY: 4,
  SEMI_ANNUALLY: 2,
  MONTHLY: 12,
} as const;

export type Mode = (typeof MODE)[keyof typeof MODE];

export const SUPPORTED_MODES = Object.values(MODE);

export const MODES: { value: Mode; title: string }[] = [
  {
    value: MODE.MONTHLY,
    title: "Paying Monthly",
  },
  {
    value: MODE.QUARTERLY,
    title: "Paying Quarterly",
  },
  {
    value: MODE.SEMI_ANNUALLY,
    title: "Paying Semi-Annually",
  },
  {
    value: MODE.ANNUALLY,
    title: "Paying Annually",
  },
];
